import * as React from 'react';

import { Typography } from '@nelnet/unifi-components-react';

import UnifiTheme from '../../themes/unifi/UnifiTheme';

interface ITypeProps {
  children: string;
  id?: string;
}

const H1 = ({ children }: ITypeProps) => (
  <UnifiTheme>
    <Typography variant="h1" margin={{ bottom: 3 }}>
      {children}
    </Typography>
  </UnifiTheme>
);

const H2 = ({ children, id, ...other }: ITypeProps) => {
  return (
    <UnifiTheme>
      <Typography variant="h2" id={id} margin={{ bottom: 3 }} {...other}>
        {children}
      </Typography>
    </UnifiTheme>
  );
};

const H3 = ({ children, id, ...other }: ITypeProps) => {
  return (
    <UnifiTheme>
      <Typography variant="h3" id={id} margin={{ bottom: 3 }} {...other}>
        {children}
      </Typography>
    </UnifiTheme>
  );
};

const H4 = ({ children }: ITypeProps) => (
  <UnifiTheme>
    <Typography variant="h4" gutterBottom>
      {children}
    </Typography>
  </UnifiTheme>
);

const H5 = ({ children }: ITypeProps) => (
  <UnifiTheme>
    <Typography variant="h5" gutterBottom>
      {children}
    </Typography>
  </UnifiTheme>
);

const H6 = ({ children }: ITypeProps) => (
  <UnifiTheme>
    <Typography variant="h6" gutterBottom>
      {children}
    </Typography>
  </UnifiTheme>
);

const P = ({ children }: ITypeProps) => (
  <UnifiTheme>
    <Typography paragraph>{children}</Typography>
  </UnifiTheme>
);

const Caption = ({ children }: ITypeProps) => (
  <UnifiTheme>
    <Typography variant="caption">{children}</Typography>
  </UnifiTheme>
);

const Body1 = ({ children }: ITypeProps) => (
  <UnifiTheme>
    <Typography variant="body1">{children}</Typography>
  </UnifiTheme>
);

const Subtitle1 = ({ children }: ITypeProps) => (
  <UnifiTheme>
    <Typography variant="subtitle1">{children}</Typography>
  </UnifiTheme>
);

const Scale = ({ children, ...other }: ITypeProps) => (
  <Typography {...other} component="p">
    {children}
  </Typography>
);

const UL = ({ children }: ITypeProps) => (
  <UnifiTheme>
    <Typography component="ul">{children}</Typography>
  </UnifiTheme>
);

const OL = ({ children }: ITypeProps) => (
  <UnifiTheme>
    <Typography component="ol">{children}</Typography>
  </UnifiTheme>
);

const LI = ({ children }: ITypeProps) => (
  <UnifiTheme>
    <Typography component="li">{children}</Typography>
  </UnifiTheme>
);

const EM = ({ children }: ITypeProps) => <em>{children}</em>;

const Strong = ({ children }: ITypeProps) => <strong>{children}</strong>;

export { H1, H2, H3, H4, H5, H6, P, Caption, Body1, Subtitle1, Scale, UL, OL, LI, EM, Strong };
